export default __webpack_public_path__ + "fonts/tpl_7.cc8e2c750236ee26edd68fab55c11be0.png";